/**
 * Full-page ending for a demo the access gate stopped (#2824, #2985).
 *
 * Shown by the demo auth providers in place of the app, so the roster, the
 * phone frame and the guide all go with it. The button ends the stored demo
 * and opens the demo page.
 */
import { inDemoPhoneFrame } from "../../lib/demoPhone";
import { leaveDemo } from "../../lib/demoSession";
import { Button } from "../ui";

export function DemoEndedScreen() {
  // Inside the phone frame the parent page shows the screen; the frame stays blank.
  if (inDemoPhoneFrame()) return null;
  return (
    <main
      role="alert"
      data-testid="demo-ended-screen"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-bg px-4 text-center font-sans text-fg"
    >
      <h1 className="text-2xl font-semibold">This demo has ended</h1>
      <p className="max-w-md text-base text-fg-muted">
        The access for this demo was closed. You can start another from the demo page.
      </p>
      <Button data-testid="demo-ended-back" onClick={() => leaveDemo("/demo")}>
        Back to the demo page
      </Button>
    </main>
  );
}
